import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import useStore from './../store.js';
import i18n from '@pureartisan/simple-i18n';
import { CoreButton, TourIcon } from './../../../core';

var PanelInfoView = function PanelInfoView(_ref) {
  var props = _extends({}, _ref); // const setStoreValues = useStore(
  //   state => state.setStoreValues,
  // )


  var activeView = useStore(function (state) {
    return state.activeView;
  });
  var enableTour = useStore(function (state) {
    return state.enableTour;
  });
  var defaultMetric = useStore(function (state) {
    return state.defaultMetric;
  });
  var defaultFilterTab = useStore(function (state) {
    return state.defaultFilterTab;
  });
  var setUpTour = useStore(function (state) {
    return state.setUpTour;
  });
  var incrementLaunchTour = useStore(function (state) {
    return state.incrementLaunchTour;
  });
  var interactionsMobile = useStore(function (state) {
    return state.interactionsMobile;
  });

  var getTourButton = function getTourButton() {
    if (!!enableTour && !!interactionsMobile) {
      return /*#__PURE__*/React.createElement(CoreButton, {
        color: "light",
        label: i18n.translate('UI_MAP_INTRO_MODAL_TOUR_BTN'),
        onClick: handleStartTour
      }, /*#__PURE__*/React.createElement(TourIcon, null), i18n.translate('UI_MAP_INTRO_MODAL_TOUR_BTN'));
    } else {
      return '';
    }
  };
  /**
   * Close the intro panel and start the tour
   */


  var handleStartTour = function handleStartTour() {
    // console.log('handleStartTour()')
    incrementLaunchTour();
    setUpTour();
  };

  var getContents = function getContents() {
    // Right now, just check for feeder OR map.
    if (activeView === 'feeder') {
      return i18n.translate('UI_PANEL_INFO_FEEDER');
    } else {
      return i18n.translate('UI_PANEL_INFO_MAP');
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "map-panel-slideout-info"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: getContents()
    }
  }), getTourButton());
};

export default PanelInfoView;